/* tslint:disable:no-string-literal */
import {Component, OnInit, HostBinding, HostListener, Input, ElementRef} from '@angular/core';

@Component({
  selector: 'exg-popup',
  templateUrl: './exg-popup.component.html',
  styleUrls: ['./exg-popup.component.scss']

})
export class ExgPopupComponent implements OnInit {

  @HostBinding('style.top') y = '0px';
  @HostBinding('style.left') x = '0px';
  @HostBinding('style.visibility') visibility = 'hidden';
  @HostBinding('style.opacity') opacity = '0';
  @Input() @HostBinding('style.width') width = 'min-content';
  @Input() closeAlways = true;
  @Input() closeOnButtonOnly = false;
  host: any = null;
  flip = false;

  constructor(host: ElementRef) {
    this.host = host.nativeElement;
  }

  open(e: MouseEvent): void {
    const cw = this.host.offsetWidth;
    this.x = `min(${e.pageX}px, calc(100vw - ${cw}px - 1rem))`;
    this.y = `${e.pageY}px`;
    this.opacity = '1';
    this.visibility = 'visible';
    this.flip = true;

  }

  openUnderLeft(e: MouseEvent): void {
    const cw = this.host.offsetWidth;
    this.x = `min(${e.pageX - e.offsetX}px, calc(100vw - ${cw}px - 1rem))`;
    // @ts-ignore
    this.y = `${e.pageY - e.offsetY + e.target['clientHeight'] + 4}px`;
    this.opacity = '1';
    this.visibility = 'visible';
    this.flip = true;
  }

  openUnderRight(e: MouseEvent): void {
    const er: DOMRect = (e.target as Element).getBoundingClientRect();
    const cw = this.host.offsetWidth;
    this.x = `max(${e.pageX - e.offsetX + er.width - cw}px, 1rem)`;
    // @ts-ignore
    this.y = `${e.pageY - e.offsetY + e.target['clientHeight'] + 4}px`;
    this.opacity = '1';
    this.visibility = 'visible';
    this.flip = true;
  }

  openUnderCenter(e: MouseEvent): void {
    const er: DOMRect = (e.target as Element).getBoundingClientRect();
    const cw = this.host.offsetWidth;
    this.x = `min(max(${e.pageX - e.offsetX + (er.width - cw) / 2}px, 1rem),calc(100vw - ${cw}px - 1rem))`;
    // @ts-ignore
    this.y = `${e.pageY - e.offsetY + e.target['clientHeight'] + 4}px`;
    this.opacity = '1';
    this.visibility = 'visible';
    this.flip = true;
  }

  openAboveCenter(e: MouseEvent): void {
    const er: DOMRect = (e.target as Element).getBoundingClientRect();
    const cw: DOMRect = (this.host as Element).getBoundingClientRect();
    this.x = `min(max(${e.pageX - e.offsetX + (er.width - cw.width) / 2}px, 1rem),calc(100vw - ${cw.width}px - 1rem))`;
    this.y = `max(${e.pageY - e.offsetY - 4 - cw.height}px, 1rem)`;
    this.opacity = '1';
    this.visibility = 'visible';
    this.flip = true;
  }


  close(): void {
    this.opacity = '0';
    setTimeout(() => {
      this.visibility = 'hidden';
    }, 300);

  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(e: MouseEvent): void {
    if (this.flip) {
      this.flip = false;
      return;
    }
    // check click inside Container
    const rect: DOMRect = (this.host as Element).getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;
    let inside = true;
    if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
      inside = false;
    }

    if (this.visibility === 'visible' && (!inside || this.closeAlways) && (!this.closeOnButtonOnly)) {
      this.close();
    }
  }

  ngOnInit(): void {
  }

}
